import Vue from 'vue'
import Bootstrap from './bootStrap/BootStrap.vue'
import router from './router'
import store from './store'
import vChart from './components/vChart/vChart.vue'
import driverType from './components/driverType/index.vue'
Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/animate.min.css'
import '@/assets/style/common.css'
// 引入iconfont图标
import '../src/assets/font/iconfont.css'

//表单验证
import { formRules } from '@/utils/validate'
Vue.prototype.$validateRules = formRules

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.component('v-chart', vChart)
Vue.component('driver-type', driverType)
 
//虚拟滚动
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller from 'vue-virtual-scroller'
Vue.use(VueVirtualScroller)


//指令
import directive from '@/directive' // directive
Vue.use(directive);


Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(Bootstrap)
}).$mount('#app')
